import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';
import { CssBaseline } from '@mui/material';
import { store } from './store';
import ThemeModeProvider from './ThemeModeProvider.jsx';
import router from './App.jsx';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeModeProvider>
        <CssBaseline />
        <RouterProvider router={router} />
      </ThemeModeProvider>
    </Provider>
  </React.StrictMode>,
);
